import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';

import { PaginatedResultModel } from '@data-layer/models/common';
import { ManagementRouteModel, ManagementUpdateRouteModel } from '@data-layer/models/management';
import { RouteModel, RouteSearchModel } from '@data-layer/models/lcl';

@Injectable({
  providedIn: 'root',
})
export class RoutesRepository {
  constructor(private apiService: ApiService) {}

  public search(params?: RouteSearchModel, isShowLoader?: boolean): Observable<PaginatedResultModel<RouteModel>> {
    return this.apiService.get<PaginatedResultModel<RouteModel>>(environment.url.freight.routes, { params }, { isShowLoader });
  }

  public searchV2(params?: RouteSearchModel, isShowLoader?: boolean): Observable<RouteModel> {
    return this.apiService.get<RouteModel>(`${environment.url.prefixFreight}v2/routes`, { params }, { isShowLoader });
  }

  public searchManagement(params?: RouteSearchModel, isShowLoader?: boolean): Observable<PaginatedResultModel<ManagementRouteModel>> {
    return this.apiService.get<PaginatedResultModel<ManagementRouteModel>>(
      environment.url.freight.routesManagement,
      { params },
      { isShowLoader },
    );
  }

  public createManagement(model: ManagementUpdateRouteModel, isShowLoader?: boolean): Observable<ManagementRouteModel> {
    return this.apiService.post<ManagementRouteModel>(environment.url.freight.routesManagement, model, null, { isShowLoader });
  }

  public getManagement(id: ManagementRouteModel['id'], isShowLoader?: boolean): Observable<ManagementRouteModel> {
    return this.apiService.get<ManagementRouteModel>(`${environment.url.freight.routesManagement}/${id}`, null, { isShowLoader });
  }

  public updateManagement(
    id: ManagementRouteModel['id'],
    model: ManagementUpdateRouteModel,
    isShowLoader?: boolean,
  ): Observable<ManagementRouteModel> {
    return this.apiService.put<ManagementRouteModel>(`${environment.url.freight.routesManagement}/${id}`, model, null, { isShowLoader });
  }

  public deleteManagement(id: ManagementRouteModel['id'], isShowLoader?: boolean): Observable<never> {
    return this.apiService.delete(`${environment.url.freight.routesManagement}/${id}`, null, { isShowLoader });
  }

  public countPortsExist(portsId?: number[], isShowLoader?: boolean): Observable<number> {
    return this.apiService.get<number>(
      `${environment.url.freight.routesManagement}/count-ports-exist`,
      { params: { portsId } },
      { isShowLoader },
    );
  }
}
